export default {
  formatEuro(value) {
    return Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(value)
  }
}
